/** Texto sem acento, sem pontuação e em minúsculas, para comparar nomes. */
export const plain = (text: string) =>
  text
    .normalize('NFD')
    .replace(/[^a-zA-Z0-9 ]/g, '')
    .toLowerCase()
    .trim();

/**
 * Acha na lista o que o dono citou pelo nome: primeiro o nome igual, depois o
 * que contém o que ele disse (ou o contrário) e, por último, o que tem todas as palavras
 * que importam do que ele disse. Sem acento e sem maiúsculas.
 */
export function matchByName<T>(list: T[], said: string, nameOf: (item: T) => string): T[] {
  const wanted = plain(said);
  if (!wanted) return [];
  const exact = list.filter((item) => plain(nameOf(item)) === wanted);
  if (exact.length > 0) return exact;
  const contained = list.filter((item) => {
    const name = plain(nameOf(item));
    return name.length > 0 && (name.includes(wanted) || wanted.includes(name));
  });
  if (contained.length > 0) return contained;
  // "freela da Ana" acha "Freela do site da Ana": todas as palavras que importam do que ele
  // disse estão no nome, em qualquer ordem.
  const words = wanted.split(/\s+/).filter((word) => word.length > 2 && !STOP.has(word));
  if (words.length === 0) return [];
  return list.filter((item) => {
    const name = new Set(plain(nameOf(item)).split(/\s+/));
    return words.every((word) => name.has(word));
  });
}

const STOP = new Set(['das', 'dos', 'que', 'pra', 'para', 'com', 'uma', 'meu', 'minha']);
